'use client'

import type { PropsWithChildren } from 'react'

import { Button, type ButtonProps } from '@repo/ui'

import type { ChainId } from '../web3.types'

import { useIsSafeAccount } from '../hooks/safe-wallet.hooks'
import { useUserAccount } from '../providers/UserAccountProvider'
import { getChain } from '../utils/chain.utils'

interface ChainMismatchButtonProps extends ButtonProps {
  desiredChainId: ChainId
}

export function ChainMismatchButton({
  children,
  desiredChainId,
  disabled,
  ...props
}: PropsWithChildren<ChainMismatchButtonProps>) {
  const { switchNetwork } = useUserAccount()
  const isSafe = useIsSafeAccount()

  const desiredChain = getChain(desiredChainId)

  return (
    <Button
      {...props}
      type="button"
      onClick={isSafe ? undefined : () => switchNetwork(desiredChain)}
      disabled={isSafe || disabled}
      data-testid="chain-mismatch-button"
    >
      {isSafe
        ? `Switch to ${desiredChain.name} in Safe`
        : (children ?? `Switch to ${desiredChain.name}`)}
    </Button>
  )
}
